module.exports = __webpack_public_path__ + "img/water.17735f95.svg";